import { render, staticRenderFns } from "./taskReview.vue?vue&type=template&id=1e6d89cb&scoped=true&"
import script from "./taskReview.vue?vue&type=script&lang=js&"
export * from "./taskReview.vue?vue&type=script&lang=js&"
import style0 from "./taskReview.vue?vue&type=style&index=0&id=1e6d89cb&scoped=true&lang=css&"
import style1 from "./taskReview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6d89cb",
  null
  
)

export default component.exports